import type { VehicleFetchInfo } from '../types.graphql'

export function getDisplayStringFromVehicleFetchInfoEndpoint(
  vehicleFetchInfo: VehicleFetchInfo
): string {
  const endpointStr = vehicleFetchInfo.integrationEndpoint.toLocaleLowerCase()

  if (endpointStr.includes('volvo')) return 'Volvo'
  if (endpointStr.includes('scania')) return 'Scania'
  if (endpointStr.includes('fleetboard')) return 'FleetBoard'
  if (endpointStr.includes('man')) return 'MAN'
  if (endpointStr.includes('3dtracking')) return '3D Tracking'
  if (endpointStr.includes('bre_digital')) return 'BRE Digital'

  return 'Devinco'
}
